import { Assets } from 'pixi.js';

export const getGameImages = () => {
  return {
    ...(Assets.get('gameImages')?.textures || {}),
    ...(Assets.get('infoSection')?.textures || {}),
  };
};
